// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.gig {
    background-color: var(--primary);/* #fee; */
    margin: var(--gig-spacing);
    border-radius: 9px;
    width: min(45vw, 300px);
    font-size: large;
    height: -webkit-fit-content;
    height: -moz-fit-content;
    height: fit-content;
}

.gig-info {
    padding: var(--gig-padding);
    padding-top: 0;
}

.gig-title {
    margin: 0;
    padding: var(--gig-padding);
    font-size: large;
    line-height: normal;
}

.gig-title:hover {
    background: rgba(255, 255, 255, 0.2);
}

.gig-title:hover .gig-collapse-icon {
    color: rgba(0,10,50,0.5);
}

.gig-collapse-icon {
    color: rgba(0,0,0,0.3);
    padding: 0 7px 0 0;
}

.ReactCollapse--collapse {
    transition: height 500ms;
}

.gig-description {
    margin: 0;
    white-space: pre-wrap;
    line-height: normal;
}

div.gig-list {
    width: 100%;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
}

table.gig-table {
    width: 100%;
    margin: 0 0 1em;
    border: none;
    border-collapse: collapse;
}

table.gig-table td:first-child {
    padding-left: var(--gig-padding);
}

table.gig-table td:last-child {
    padding-right: var(--gig-padding);
}

table.gig-table tr {
    padding: 0 var(--gig-padding);
}

table.gig-table tr:nth-child(even) {
    background-color: var(--primary-light);
}

table.gig-table tr:nth-child(odd) {
    background-color: var(--primary-dark);
}

div.flux-container {
    display: flex;
}

div.flux-container > div.left {
    width:50%;
}

div.flux-container > div.right {
    width:50%;
}`, "",{"version":3,"sources":["webpack://./src/css/gig.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC,CAAC,UAAU;IAC3C,0BAA0B;IAC1B,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,2BAAmB;IAAnB,wBAAmB;IAAnB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,SAAS;IACT,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb","sourcesContent":["div.gig {\n    background-color: var(--primary);/* #fee; */\n    margin: var(--gig-spacing);\n    border-radius: 9px;\n    width: min(45vw, 300px);\n    font-size: large;\n    height: fit-content;\n}\n\n.gig-info {\n    padding: var(--gig-padding);\n    padding-top: 0;\n}\n\n.gig-title {\n    margin: 0;\n    padding: var(--gig-padding);\n    font-size: large;\n    line-height: normal;\n}\n\n.gig-title:hover {\n    background: rgba(255, 255, 255, 0.2);\n}\n\n.gig-title:hover .gig-collapse-icon {\n    color: rgba(0,10,50,0.5);\n}\n\n.gig-collapse-icon {\n    color: rgba(0,0,0,0.3);\n    padding: 0 7px 0 0;\n}\n\n.ReactCollapse--collapse {\n    transition: height 500ms;\n}\n\n.gig-description {\n    margin: 0;\n    white-space: pre-wrap;\n    line-height: normal;\n}\n\ndiv.gig-list {\n    width: 100%;\n    margin: 0;\n    display: flex;\n    flex-wrap: wrap;\n}\n\ntable.gig-table {\n    width: 100%;\n    margin: 0 0 1em;\n    border: none;\n    border-collapse: collapse;\n}\n\ntable.gig-table td:first-child {\n    padding-left: var(--gig-padding);\n}\n\ntable.gig-table td:last-child {\n    padding-right: var(--gig-padding);\n}\n\ntable.gig-table tr {\n    padding: 0 var(--gig-padding);\n}\n\ntable.gig-table tr:nth-child(even) {\n    background-color: var(--primary-light);\n}\n\ntable.gig-table tr:nth-child(odd) {\n    background-color: var(--primary-dark);\n}\n\ndiv.flux-container {\n    display: flex;\n}\n\ndiv.flux-container > div.left {\n    width:50%;\n}\n\ndiv.flux-container > div.right {\n    width:50%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
